"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSuspensionStatus = void 0;

var _immutable = require("immutable");

var _ActionTypes = require("./ActionTypes");

var _Suspension = require("../api/Suspension");

var _logging = require("../utils/logging");

var suspensionStatusPromise;

var buildSuspensionStateFromResponse = function buildSuspensionStateFromResponse(data) {
  return (0, _immutable.Map)({
    suspended: data.suspended,
    canAppeal: data.canAppeal,
    appealState: data.appealState
  });
};

var fetchSuspensionStatus = function fetchSuspensionStatus(hostApp) {
  return function (dispatch, getState, httpClient) {
    if (suspensionStatusPromise) {
      return suspensionStatusPromise;
    }

    dispatch({
      type: _ActionTypes.FETCH_SUSPENSION_STATE_ATTEMPTED
    });
    suspensionStatusPromise = (0, _Suspension.requestSuspensionStatus)(httpClient, hostApp).then(function (data) {
      data = buildSuspensionStateFromResponse(data);
      dispatch({
        type: _ActionTypes.FETCH_SUSPENSION_STATE_SUCCEEDED,
        data: data
      });
    }).catch(function (err) {
      (0, _logging.reportError)(err, {
        action: _ActionTypes.FETCH_SUSPENSION_STATE_FAILED
      });
      dispatch({
        type: _ActionTypes.FETCH_SUSPENSION_STATE_FAILED
      });
    });
    return suspensionStatusPromise;
  };
};

exports.fetchSuspensionStatus = fetchSuspensionStatus;